<template>
  <Dialog v-model="show" max_width="94%"
          :title="$t('Detalle de las comisiones del empleado')">
    <!-- Contenido del Dialog -->
    <template v-slot:content>
      <h1 class="text-center mt-3"><span class="chart-title">{{ $t('Ventas') }} {{ empleado.first_name }}</span></h1>
      <h3 class="my-7">{{ $t('Número de clientes atendidos') }}: {{ num_clientes }}</h3>
      <v-row>
        <!-- Servicios -->
        <v-col cols="12" md="6" lg="4">
          <h2 class="text-center mb-4">{{ $t('Servicios') }}</h2>
          <v-data-table
              :headers="tabla_servicios.headers"
              :items="items.servicios"
              :fixed-header="true"
              class="elevation-3"
              :no-data-text="$t('No hay datos')"
              calculate-widths
          >
            <template v-slot:item.total_linea="{item}">
              {{ item.total_linea }} {{ $store.state.centro.centro.divisa_obj.simbolo }}
            </template>

            <template v-slot:item.tipo="{item}">
              {{ $t(item.tipo) }}
            </template>
            <!-- Añadimos el total -->
            <template v-slot:body.append>
              <tr>
                <td v-for="(header, i) in tabla_servicios.headers" :key="i">
                  <span v-if="i === 0" class="font-weight-bold">{{ $t('Total') }}</span>
                  <span v-else-if="i === tabla_servicios.headers.length - 1" class="font-weight-bold">{{
                      tabla_servicios.total
                    }} {{ $store.state.centro.centro.divisa_obj.simbolo }}</span>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-col>

        <!-- Productos -->
        <v-col cols="12" md="6" lg="4">
          <h2 class="text-center mb-4">{{ $t('Productos') }}</h2>
          <v-data-table
              :headers="tabla_productos.headers"
              :items="tabla_productos.items"
              :fixed-header="true"
              class="elevation-3"
              :no-data-text="$t('No hay datos')"
              calculate-widths
          >
            <template v-slot:item.total_linea="{item}">
              {{ item.total_linea }} {{ $store.state.centro.centro.divisa_obj.simbolo }}
            </template>

            <template v-slot:item.tipo="{item}">
              {{ $t(item.tipo) }}
            </template>

            <template v-slot:item.costes="{item}">
              {{ item.costes }} {{ $store.state.centro.centro.divisa_obj.simbolo }}
            </template>
            <template v-slot:item.beneficios="{item}">
              {{ item.total_linea - item.precio_coste }} {{ $store.state.centro.centro.divisa_obj.simbolo }}
            </template>
            <!-- Añadimos el total -->
            <template v-slot:body.append>
              <tr>
                <td v-for="(header, i) in tabla_productos.headers" :key="i">
                  <span v-if="i === 0" class="font-weight-bold">{{ $t('Total') }}</span>
                  <span v-else-if="i === tabla_productos.headers.length - 3" class="font-weight-bold">{{
                      tabla_productos.total_ingresos
                    }} {{ $store.state.centro.centro.divisa_obj.simbolo }}</span>
                  <span v-else-if="i === tabla_productos.headers.length - 2" class="font-weight-bold">{{
                      tabla_productos.total_costes
                    }} {{ $store.state.centro.centro.divisa_obj.simbolo }}</span>
                  <span v-else-if="i === tabla_productos.headers.length - 1" class="font-weight-bold">{{
                      tabla_productos.total_beneficios
                    }} {{ $store.state.centro.centro.divisa_obj.simbolo }}</span>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-col>

        <!-- Packs -->
        <v-col cols="12" md="6" lg="4">
          <h2 class="text-center mb-4">{{ $t('Packs') }}</h2>
          <v-data-table
              :headers="tabla_packs.headers"
              :items="items.packs"
              :fixed-header="true"
              class="elevation-3"
              :no-data-text="$t('No hay datos')"
              calculate-widths
          >
            <template v-slot:item.total_linea="{item}">
              {{ item.total_linea }} {{ $store.state.centro.centro.divisa_obj.simbolo }}
            </template>

            <template v-slot:item.tipo="{item}">
              {{ $t(item.tipo) }}
            </template>
            <!-- Añadimos el total -->
            <template v-slot:body.append>
              <tr>
                <td v-for="(header, i) in tabla_packs.headers" :key="i">
                  <span v-if="i === 0" class="font-weight-bold">{{ $t('Total') }}</span>
                  <span v-else-if="i === tabla_packs.headers.length - 1" class="font-weight-bold">{{
                      tabla_packs.total
                    }} {{ $store.state.centro.centro.divisa_obj.simbolo }}</span>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-col>

        <!-- Bonos -->
        <v-col cols="12" md="6" lg="4">
          <h2 class="text-center mb-4">{{ $t('Bonos') }}</h2>
          <v-data-table
              :headers="tabla_bonos.headers"
              :items="items.bonos"
              :fixed-header="true"
              class="elevation-3"
              :no-data-text="$t('No hay datos')"
              calculate-widths
          >
            <template v-slot:item.total_linea="{item}">
              {{ item.total_linea }} {{ $store.state.centro.centro.divisa_obj.simbolo }}
            </template>

            <template v-slot:item.tipo="{item}">
              {{ $t(item.tipo) }}
            </template>
            <!-- Añadimos el total -->
            <template v-slot:body.append>
              <tr>
                <td v-for="(header, i) in tabla_bonos.headers" :key="i">
                  <span v-if="i === 0" class="font-weight-bold">{{ $t('Total') }}</span>
                  <span v-else-if="i === tabla_bonos.headers.length - 1" class="font-weight-bold">{{
                      tabla_bonos.total
                    }} {{ $store.state.centro.centro.divisa_obj.simbolo }}</span>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-col>

        <!-- Sesiones bono -->
        <v-col cols="12" md="6" lg="4">
          <h2 class="text-center mb-4">{{ $t('Sesiones bono') }}</h2>
          <v-data-table
              :headers="tabla_sesion.headers"
              :items="items.sesion_bonos"
              :fixed-header="true"
              class="elevation-3"
              :no-data-text="$t('No hay datos')"
              calculate-widths
          >
            <template v-slot:item.total_linea="{item}">
              {{ item.total_linea }} {{ $store.state.centro.centro.divisa_obj.simbolo }}
            </template>

            <template v-slot:item.tipo="{item}">
              {{ $t(item.tipo) }}
            </template>
            <!-- Añadimos el total -->
            <template v-slot:body.append>
              <tr>
                <td v-for="(header, i) in tabla_sesion.headers" :key="i">
                  <span v-if="i === 0" class="font-weight-bold">{{ $t('Total') }}</span>
                  <span v-else-if="i === tabla_sesion.headers.length - 1" class="font-weight-bold">{{
                      tabla_sesion.total
                    }} {{ $store.state.centro.centro.divisa_obj.simbolo }}</span>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-col>

        <!-- Tarjetas -->
        <v-col cols="12" md="6" lg="4">
          <h2 class="text-center mb-4">{{ $t('Venta tarjetas') }}</h2>
          <v-data-table
              :headers="tabla_tarjetas.headers"
              :items="items.tarjetas"
              :fixed-header="true"
              class="elevation-3"
              :no-data-text="$t('No hay datos')"
              calculate-widths
          >
            <template v-slot:item.total_linea="{item}">
              {{ item.total_linea }} {{ $store.state.centro.centro.divisa_obj.simbolo }}
            </template>

            <template v-slot:item.tipo="{item}">
              {{ $t(item.tipo) }}
            </template>
            <!-- Añadimos el total -->
            <template v-slot:body.append>
              <tr>
                <td v-for="(header, i) in tabla_tarjetas.headers" :key="i">
                  <span v-if="i === 0" class="font-weight-bold">{{ $t('Total') }}</span>
                  <span v-else-if="i === tabla_tarjetas.headers.length - 1" class="font-weight-bold">{{
                      tabla_tarjetas.total
                    }} {{ $store.state.centro.centro.divisa_obj.simbolo }}</span>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </template>
  </Dialog>
</template>

<script>

export default {
  name: "DialogComisionesEmpleadoDetalle",

  props: ['value', 'empleado', 'items', 'num_clientes'],

  data: () => ({
    numero_clientes_atendidos: 0,
    tabla_servicios: {
      headers: [],
      total: 0
    },
    tabla_productos: {
      headers: [],
      items: [],
      total_ingresos: 0,
      total_costes: 0,
      total_beneficios: 0
    },
    tabla_bonos: {
      headers: [],
      total: 0
    },
    tabla_packs: {
      headers: [],
      total: 0
    },
    tabla_sesion: {
      headers: [],
      total: 0
    },
    tabla_tarjetas: {
      headers: [],
      total: 0
    }
  }),

  async mounted() {
    // Inicializamos las cabeceras de las tablas

    // Servicios
    this.tabla_servicios.headers = [
      {text: this.$t('Cantidad'), value: 'cantidad', class: 'primary white--text', sortable: false},
      {text: this.$t('Servicio'), value: 'descripcion', class: 'primary white--text', sortable: false},
      {text: this.$t('Ingresos'), value: 'total_linea', class: 'primary white--text', sortable: false}
    ]
    // Productos
    this.tabla_productos.headers = [
      {text: this.$t('Cantidad'), value: 'cantidad', class: 'primary white--text', sortable: false},
      {text: this.$t('Código barras'), value: 'barcode', class: 'primary white--text', sortable: false},
      {text: this.$t('Referencia'), value: 'ref', class: 'primary white--text', sortable: false},
      {text: this.$t('Producto'), value: 'text', class: 'primary white--text', sortable: false},
      {text: this.$t('Ingresos'), value: 'total_linea', class: 'primary white--text', sortable: false},
      {text: this.$t('Costes'), value: 'precio_coste', class: 'primary white--text', sortable: false},
      {text: this.$t('Beneficios'), value: 'beneficios', class: 'primary white--text', sortable: false}
    ]
    // Bonos
    this.tabla_bonos.headers = [
      {text: this.$t('Cantidad'), value: 'cantidad', class: 'primary white--text', sortable: false},
      {text: this.$t('Bono'), value: 'descripcion', class: 'primary white--text', sortable: false},
      {text: this.$t('Ingresos'), value: 'total_linea', class: 'primary white--text', sortable: false}
    ]
    // Packs
    this.tabla_packs.headers = [
      {text: this.$t('Cantidad'), value: 'cantidad', class: 'primary white--text', sortable: false},
      {text: this.$t('Pack'), value: 'descripcion', class: 'primary white--text', sortable: false},
      {text: this.$t('Ingresos'), value: 'total_linea', class: 'primary white--text', sortable: false}
    ]
    // Sesion bonos
    this.tabla_sesion.headers = [
      {text: this.$t('Cantidad'), value: 'cantidad', class: 'primary white--text', sortable: false},
      {text: this.$t('Concepto'), value: 'descripcion', class: 'primary white--text', sortable: false},
      {text: this.$t('Tipo'), value: 'tipo', class: 'primary white--text', sortable: false},
      {text: this.$t('Ingresos'), value: 'total_linea', class: 'primary white--text', sortable: false}
    ]
    // Tarjetas
    this.tabla_tarjetas.headers = [
      {text: this.$t('Cantidad'), value: 'cantidad', class: 'primary white--text', sortable: false},
      {text: this.$t('Descripción'), value: 'descripcion', class: 'primary white--text', sortable: false},
      {text: this.$t('Tipo'), value: 'tipo', class: 'primary white--text', sortable: false},
      {text: this.$t('Ingresos'), value: 'total_linea', class: 'primary white--text', sortable: false}
    ]

    this.tabla_productos.items = [...this.items.productos]

    await this.get_detalles_productos()
    this.get_totales()
  },

  methods: {
    get_totales(){
      this.tabla_servicios.total = this.items.servicios.reduce((total, item)=> item.total_linea + total, 0)

      this.tabla_productos.total_ingresos = this.tabla_productos.items.reduce((total, item)=> item.total_linea + total, 0)
      this.tabla_productos.total_costes = this.tabla_productos.items.reduce((total, item)=> item.precio_coste + total, 0)
      this.tabla_productos.total_beneficios = this.tabla_productos.total_ingresos - this.tabla_productos.total_costes

      this.tabla_packs.total = this.items.packs.reduce((total, item)=> item.total_linea + total, 0)
      this.tabla_bonos.total = this.items.bonos.reduce((total, item)=> item.total_linea + total, 0)
      this.tabla_sesion.total = this.items.sesion_bonos.reduce((total, item)=> item.total_linea + total, 0)
      this.tabla_tarjetas.total = this.items.tarjetas.reduce((total, item)=> item.total_linea + total, 0)
    },

    async get_detalles_productos(){
      let filtro = this.items.productos.reduce((lista, item)=> item.id + ',' + lista, '')
      const result = await this.$store.dispatch('producto/get_from_lineas_venta', {params: {lineas: filtro}})

      for (let item of result.data) {
        this.tabla_productos.items.forEach((linea, index)=>{
          if (linea.id === item.id) {
            this.tabla_productos.items[index] = {...linea, ...item.producto}
          }
        })
      }

      this.tabla_productos.items = [...this.tabla_productos.items]
    }
  },

  computed: {
    show: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  },
}
</script>
<style scoped>
/* Title of the dialog */
.chart-title {
  border-radius: 5px;
  border: 3px solid grey;
  padding: 5px
}
</style>